module.exports = __webpack_public_path__ + "static/media/hands-up-4-kids.17ede79e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/hands-up-4-kids.jpg
// module id = 185
// module chunks = 0